import { jsx as s } from "react/jsx-runtime";
import { forwardRef as c } from "react";
import { P as n } from "./Pill-uAcQLotY.js";
const l = {
  active: "success",
  paused: "purple",
  error: "error",
  limited: "warning",
  // PROJECT-STATE §4.F.21 — transient state shown after Reconnect; tone
  // matches the `reconnecting` palette entry in `tokens/palettes.ts`.
  reconnecting: "accent"
}, u = c(
  function({ status: t, variant: r = "soft", size: o = "sm", children: e, ...a }, i) {
    return /* @__PURE__ */ s(
      n,
      {
        ref: i,
        tone: l[t],
        variant: r,
        size: o,
        "data-status": t,
        role: "status",
        "aria-live": "polite",
        ...a,
        children: e
      }
    );
  }
);
u.displayName = "AccountStatusPill";
export {
  u as A
};
//# sourceMappingURL=AccountStatusPill-Cz8VkI3p.js.map
